import React, { useEffect } from "react";
import { Form, Input, Row, Button, Col, Card, notification } from 'antd';
import { insertEnquiry } from "../../actions/Guest-action";
import { action } from "../../store";
import { connect } from "react-redux";
import { resetAllStatus } from "../../actions/Authentication-action";

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not validate email!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

const Enquiry = ({ guest: { isEnquirySubmitted }, profile }) => {
  const [form] = Form.useForm();
  const onFinish = (values, e) => {
    let enquiry = values;
    if (profile && profile.email) {
      enquiry.user.email = profile.email
    }
    action(
      insertEnquiry({
        ...enquiry
      })
    );
  };
  notification.config({
    duration: 20
  })
  useEffect(() => {

    if (isEnquirySubmitted) {
      notification["success"]({
        message: "Query Submitted Successfully"
      });

      action(
        resetAllStatus()
      );
      form.resetFields();
    }
  }, [isEnquirySubmitted]);

  return (
    <Row align="center">
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <Card title="Enquiry">
          <Row>
            <Col span={24}>
              {/* <h1></h1> */}
              <Form {...layout} layout="vertical" form={form} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages}>
                {
                  !profile || !profile.email ? (
                    <Form.Item name={['user', 'email']} label="Email" rules={[{ type: 'email' }, { required: true }]}>
                      <Input />
                    </Form.Item>
                  ) : ""
                }
                <Form.Item name={['user', 'title']} label="Title" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Form.Item name={['user', 'message']} label="Message" rules={[{ required: true }]}>
                  <Input.TextArea />
                </Form.Item>
                <div>
                  <Button type="primary" htmlType="submit" style={{ float: "right" }}>
                    Submit
                  </Button>
                </div>
              </Form>
            </Col>
            {/* <Col span={2}></Col> */}
          </Row>
        </Card>

      </Col>
    </Row>

  );
};

const mapStateToProps = (state) => {
  const { GuestReducer } = state;
  return { guest: GuestReducer }
}

export default connect(mapStateToProps)(Enquiry)